export default () => ({
  loading: false,
  isShowPrice: false,
  showLabelSearch: false,
  scheduleTotal: null,
  notShow: false,
  isBlock: false,
  schedules: {},
  search: {
    specialityName: null,
    speciality: null,
    city: null,
    cityName: null,
    operator: 'sanepar'
  },
  location: '',
  nameCities: '',
  ipstack: '',
  operatorCovenant: null,
  text: 'Aguarde Processando Busca...',
  dark: false,
  classes: null,
  background: null,
  customLoader: null,
  mbloading: false,
  totalAgendas: 0
})



// WEBPACK FOOTER //
// ./src/app/patient/loading-page/gadget/resources/data.js